
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"16","viewBox":"0 0 15 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.54273 7.90069V10.9861C1.54273 11.6264 2.05954 12.1432 2.69977 12.1432C3.34 12.1432 3.85682 11.6264 3.85682 10.9861V7.90069C3.85682 7.26046 3.34 6.74364 2.69977 6.74364C2.05954 6.74364 1.54273 7.26046 1.54273 7.90069ZM6.17091 7.90069V10.9861C6.17091 11.6264 6.68772 12.1432 7.32795 12.1432C7.96818 12.1432 8.48499 11.6264 8.48499 10.9861V7.90069C8.48499 7.26046 7.96818 6.74364 7.32795 6.74364C6.68772 6.74364 6.17091 7.26046 6.17091 7.90069ZM1.15704 16H13.4989C14.1391 16 14.6559 15.4832 14.6559 14.843C14.6559 14.2027 14.1391 13.6859 13.4989 13.6859H1.15704C0.516813 13.6859 0 14.2027 0 14.843C0 15.4832 0.516813 16 1.15704 16ZM10.7991 7.90069V10.9861C10.7991 11.6264 11.3159 12.1432 11.9561 12.1432C12.5964 12.1432 13.1132 11.6264 13.1132 10.9861V7.90069C13.1132 7.26046 12.5964 6.74364 11.9561 6.74364C11.3159 6.74364 10.7991 7.26046 10.7991 7.90069ZM6.61058 0.179342L0.516813 3.38821C0.200554 3.5502 0 3.88188 0 4.23671C0 4.76895 0.431963 5.20092 0.964204 5.20092H13.6994C14.2239 5.20092 14.6559 4.76895 14.6559 4.23671C14.6559 3.88188 14.4553 3.5502 14.1391 3.38821L8.04532 0.179342C7.59793 -0.0597806 7.05797 -0.0597806 6.61058 0.179342Z","fill":"#B8B8B8"}})])
          )
        }
      }
    